import {
	AspectRatio,
	Badge,
	Box,
	Button,
	ButtonGroup,
	Container,
	Flex,
	Heading,
	IconButton,
	Image,
	SimpleGrid,
	Stack,
	Text,
	List,
	ListItem,
	ListIcon,
	Popover,
	PopoverTrigger,
	PopoverContent,
	PopoverArrow,
	PopoverBody,
	PopoverHeader,
	Spinner,
	Center,
	HStack,
} from '@chakra-ui/react'
import {
	FacebookShareButton,
	FacebookIcon,
	LinkedinShareButton,
	LinkedinIcon,
	EmailShareButton,
	EmailIcon,
	TwitterShareButton,
	TwitterIcon,
	WhatsappShareButton,
	WhatsappIcon,
} from 'react-share'
import PageSearchForm from '../components/PageSearchForm'
import { FiShare2 } from 'react-icons/fi'
import {
	FaFacebook,
	FaTwitter,
	FaLinkedin,
	FaYoutube,
	FaInstagram,
} from 'react-icons/fa'
import { Link, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getRequest } from '../services/base.service'
import XIcon from '../icons/XIcon'

const BusinessDetails = () => {
	const [isLoading, setIsLoading] = useState(true)
	const [business, setBusiness] = useState(null)

	const { slug } = useParams()
	const auth = useSelector((state) => state.auth)
	useEffect(() => {
		getRequest(`business/details/${slug}`)
			.then((res) => {
				setBusiness(res.result)
				setIsLoading(false)
			})
			.catch((error) => {
				setIsLoading(false)
				console.log(error)
			})
	}, [slug])

	const objArrToStrArr = (objArr = [], keyName = 'name') => {
		return objArr.map((item) => item[keyName])
	}

	const showPricing = (qnt = 1) => {
		let dollarSigns = ''
		for (let i = 1; i <= qnt; i++) {
			dollarSigns = dollarSigns + '$'
		}
		return dollarSigns
	}

	const loggedinUser = JSON.parse(localStorage.getItem('user'));
	const showClaimButton = loggedinUser && business?.user_id != loggedinUser.id;

	const validOperatingHours = business?.operating_hours?.filter(
		(item) => item?.start_time && item?.end_time
	);

	return (
		<>
			{/* <Box
				py={'8'}
				borderBottomWidth={'1px'}
				borderBottomStyle={'solid'}
				borderColor={'gray.300'}
			>
				<Container maxW={'container.xl'}>
					<PageSearchForm />
				</Container>
			</Box> */}

			{!isLoading ? (
				<Box>
					<Container py={5} maxW={'container.xl'}>
						{business.business_images.length > 0 && (
							<Box
								pb={5}
								display={['none', 'none', 'block', 'block']}
								borderBottomColor={'gray.300'}
								borderBottomStyle={'solid'}
								borderBottomWidth={'1px'}
							>
								<SimpleGrid gap={2} columns={5}>
									{business.business_images.map((img, index) => (
										<AspectRatio key={index}>
											<Image
												src={img.image}
												h="100%"
												w="100j%"
												objectFit={'cover'}
											/>
										</AspectRatio>
									))}
								</SimpleGrid>
							</Box>
						)}

						<Box pt={5}>
							<Box display={['block', 'block', 'flex', 'flex']}>
								<AspectRatio
									mx={['auto', 'auto', '0', '0']}
									w={'200px'}
									h={'200px'}
									ratio={1}
									bg={'gray.100'}
								>
									<Image
										w="100%"
										h="100%"
										objectFit={'contain'}
										p={3}
										src={business?.logo}
										alt={business?.name}
									/>
								</AspectRatio>

								<Box
									textAlign={['center', 'center', 'left', 'left']}
									w={[
										'100%',
										'100%',
										'calc(100% - 200px)',
										'calc(100% - 200px)',
									]}
									ps={[0, 0, 6, 6]}
								>
									<Box
										display={['block', 'block', 'flex', 'flex']}
										justifyContent={'space-between'}
										alignItems={'center'}
									>
										<Heading
											as={'h2'}
											mt={['2', '2', 0, 0]}
											textAlign={['center', 'center', 'left', 'left']}
											fontSize={'1.5rem'}
										>
											{business?.name}
											<Badge fontSize={'1rem'} ml={'3'} colorScheme={'green'}>
												{business?.current_status}
											</Badge>

											{auth?.user?.id === business?.user_id && (
											<Button
													as={Link}
													to={`/business/${business?.id}/edit`}
													size={'sm'}
													colorScheme={'blue'}
													ml={3}
												>
													EDIT
											</Button>
											)}
										</Heading>
										<Flex mt={[0, 0, 0, 0]} gap={2}>
											{showClaimButton && (
												// <Box mt={[0, 0, 0, 0]}>
													<ButtonGroup
														isAttached
														variant="outline"
														colorScheme={'orange'}
													>
														<Button
															as={Link}
															to={`/claim-your-business/${business?.id}`}
															mr="-px"
														>
															Claim Business
														</Button>
													</ButtonGroup>
												// </Box>
											)}
										{/* <Box mt={[0, 0, 0, 0]}> */}
											<ButtonGroup
												isAttached
												variant="outline"
												colorScheme={'orange'}
											>
												<Popover placement={'bottom-end'}>
													<PopoverTrigger>
														<IconButton
															icon={<FiShare2 />}
															aria-label={'Share'}
														/>
													</PopoverTrigger>
													<PopoverContent>
														<PopoverArrow />
														<PopoverHeader>Share this business</PopoverHeader>
														<PopoverBody>
															<HStack spacing={2}>
																<FacebookShareButton
																	url={window.location.href}
																	quote={`${business?.name}`}
																	description={`${business?.bio}`}
																>
																	<FacebookIcon size={32} round />
																</FacebookShareButton>

																<EmailShareButton
																	url={window.location.href}
																	title={`${business?.name}`}
																	description={`${business?.bio}`}
																>
																	<EmailIcon size={32} round />
																</EmailShareButton>

																<LinkedinShareButton
																	url={window.location.href}
																	title={`${business?.name}`}
																	summary={`${business?.bio}`}
																>
																	<LinkedinIcon size={32} round />
																</LinkedinShareButton>

																<TwitterShareButton
																	url={window.location.href}
																	title={`${business?.name}`}
																	via={`${business?.name}`}
																>
																	<XIcon size={32} round />
																</TwitterShareButton>

																<WhatsappShareButton
																	url={window.location.href}
																	title={`${business?.name}`}
																>
																	<WhatsappIcon size={32} round />
																</WhatsappShareButton>
															</HStack>
														</PopoverBody>
													</PopoverContent>
												</Popover>
											</ButtonGroup>
										{/* </Box> */}
										</Flex>
									</Box>
									{business?.is_claimed && (
										<Badge ml={2} colorScheme="purple" fontSize="0.9rem">
											Claimed
										</Badge>
										)}
									<Stack
										mt="4"
										alignItems={['center', 'center', 'baseline', 'baseline']}
									>
										{business?.website && (
											<Flex>
												<Text fontWeight={'500'}>Website: </Text>
												<Text ml={'3'} as={'a'} href={business?.website} target={'_blank'}>
													{business?.website}
												</Text>

											</Flex>
										)}
										{business?.business_type == 'rentmy_store' &&	( <Text
											ml={'3'}
											as={'a'}
											href={business?.website}
											target={'_blank'}
										>
											<Button
											size={'sm'}
											w={'full'}
											type={'button'}
											bg={'brand.500'}
											color={'brand.50'}
											_hover={{
												bg: 'brand.600',
												color: 'white',
											}}
											_focus={{
												bg: 'brand.700',
												color: 'white',
											}}
											_active={{
												bg: 'brand.700',
												color: 'white',
											}}
										>
											Book Online
										</Button>
										</Text>
										)}

										{business?.phone && (
											<Flex>
												<Text fontWeight={'500'}>Phone: </Text>
												<Text ml={'3'}>{business?.phone}</Text>
											</Flex>
										)}

										{business?.whatsapp_no && (
											<Flex>
												<Text fontWeight={'500'}>WhatsApp: </Text>
												<Text ml={'3'}>{business?.whatsapp_no}</Text>
											</Flex>
										)}

										{business?.email && (
											<Flex>
												<Text fontWeight={'500'}>Email: </Text>
												<Text ml={'3'}>{business?.email}</Text>
											</Flex>
										)}
									</Stack>
								</Box>
							</Box>

							{business?.bio && (
								<Box mt={6}>
									<Heading as={'h4'} fontSize={'1.1rem'}>
										Company Bio
									</Heading>
									<Text mt={4}>{business.bio}</Text>
								</Box>
							)}

							<SimpleGrid columns={{ base: 1, md: validOperatingHours?.length > 0 ? 2 : 1 }} spacing={10} mt={6}>
								{/* Left Column: Opening Hours */}
								{validOperatingHours?.length > 0 && (
									<Box>
										<Heading as={'h4'} fontSize={'1.1rem'}>
										Opening Hours
										</Heading>

										<Stack spacing={2} mt={4}>
											{validOperatingHours.map((item, index) => (
												<Text key={index} display={'flex'}>
												<Text as="span" w={'200px'} fontWeight={'500'} me={4}>
													{item.day}
												</Text>
												{item?.start_time} - {item?.end_time}
												</Text>
											))}
										</Stack>
									</Box>
								)}

								{/* Right Column: Other Info */}
								<Box>
									{/* {business?.industry && (
										<Box mb={6}>
										<Heading as={'h4'} fontSize={'1.1rem'}>
											Industry
										</Heading>
										<Text mt={4}>{business.industry?.name}</Text>
										</Box>
									)} */}
									<Box mb={6}>
										<Heading as={'h4'} fontSize={'1.1rem'}>
										Insustry
										</Heading>
										<Box mt={4}>
										{objArrToStrArr(business?.industries).join(', ')}
										</Box>
									</Box>

									<Box mb={6}>
										<Heading as={'h4'} fontSize={'1.1rem'}>
										Product Categories
										</Heading>
										<Box mt={4}>
										{objArrToStrArr(business?.product_categories).join(', ')}
										</Box>
									</Box>

									<Box mb={6}>
										<Heading as={'h4'} fontSize={'1.1rem'}>
										Products
										</Heading>
										<Box mt={4}>{objArrToStrArr(business?.products).join(', ')}</Box>
									</Box>

									{/* {business.current_status && ( */}
										<Box mb={6}>
											<Heading as={'h4'} fontSize={'1.1rem'}>
											Current Status
											</Heading>
											<Box mt={4}>{business?.current_status}</Box>
										</Box>
									{/* )} */}

									{/* {Array.isArray(business?.current_offers) && business.current_offers.length > 0 && ( */}
										<Box mb={6}>
											<Heading as={'h4'} fontSize={'1.1rem'}>
											Current Offers
											</Heading>
											<Box mt={4}>
											{objArrToStrArr(business?.current_offers, 'offer').join(', ')}
											</Box>
										</Box>
									{/* )} */}

									<Box mb={6}>
										<Heading as={'h4'} fontSize={'1.1rem'}>
										Pricing
										</Heading>
										<Box mt={4}>{showPricing(business?.pricing || 1)}</Box>
									</Box>
								</Box>
							</SimpleGrid>
							<Box mt={6}>
								<Heading as={'h4'} fontSize={'1.1rem'}>
									Address and GEO Location
								</Heading>

								<Box mt={4}>
									<SimpleGrid columns={2}>
										<Stack spacing={2}>
											{business.address1 && (
												<Flex>
													<Text fontWeight={'500'} as={'span'} me={4}>
														Address 1:
													</Text>
													{business?.address1}
												</Flex>
											)}
											{business?.address2 && (
												<Flex>
													<Text fontWeight={'500'} as={'span'} me={4}>
														Address 2:
													</Text>
													{business?.address2}
												</Flex>
											)}
											{business?.city && (
												<Flex>
													<Text fontWeight={'500'} as={'span'} me={4}>
														City:
													</Text>
													{business?.city?.name}
												</Flex>
											)}
											{business?.state && (
												<Flex>
													<Text fontWeight={'500'} as={'span'} me={4}>
														State/Province:
													</Text>
													{business?.state?.name}
												</Flex>
											)}

											{business?.zip_code && (
												<Flex>
													<Text fontWeight={'500'} as={'span'} me={4}>
														Zip Code:
													</Text>
													{business?.zip_code}
												</Flex>
											)}
											{business?.country && (
												<Flex>
													<Text fontWeight={'500'} as={'span'} me={4}>
														Country:
													</Text>
													{business?.country?.name}
												</Flex>
											)}
											{/* {business?.lat && ( */}
												<Flex>
													<Text fontWeight={'500'} as={'span'} me={4}>
														Latitude:
													</Text>
													{business?.lat}
												</Flex>
											{/* )} */}
											{/* {business?.long && ( */}
												<Flex>
													<Text fontWeight={'500'} as={'span'} me={4}>
														Longitude:
													</Text>
													{business?.long}
												</Flex>
											{/* )} */}
										</Stack>

										{business?.lat && business?.long && (
											<AspectRatio ratio={16 / 7}>
												<iframe
													title={business?.name}
													style={{ width: '100%', height: '100%' }}
													src={
														'https://maps.google.com/maps?q=' +
														business?.lat +
														',' +
														business?.long +
														'&t=&z=15&ie=UTF8&iwloc=&output=embed'
													}
												/>
											</AspectRatio>
										)}
									</SimpleGrid>
								</Box>
							</Box>

							<Box mt={6}>
								<Heading as={'h4'} fontSize={'1.1rem'}>
									Social
								</Heading>

								<List mt={'4'} spacing={3}>
									{business?.facebook && (
										<ListItem>
											<ListIcon as={FaFacebook} color="facebook.500" />
											{business?.facebook}
										</ListItem>
									)}

									{business?.twitter && (
										<ListItem>
											<ListIcon as={FaTwitter} color="twitter.500" />
											{business?.twitter}
										</ListItem>
									)}
									{business?.youtube && (
										<ListItem>
											<ListIcon as={FaYoutube} color="red.500" />
											{business?.youtube}
										</ListItem>
									)}
									{business?.instagram && (
										<ListItem>
											<ListIcon as={FaInstagram} color="purple.500" />
											{business?.instagram}
										</ListItem>
									)}
									{business?.linkedin && (
										<ListItem>
											<ListIcon as={FaLinkedin} color="linkedin.500" />
											{business?.linkedin}
										</ListItem>
									)}
								</List>
							</Box>
						</Box>
					</Container>
				</Box>
			) : (
				<Box>
					<Container py={5} maxW={'container.xl'}>
						<Center h={'300px'}>
							<Box>
								<Spinner
									thickness="4px"
									speed="0.65s"
									emptyColor="gray.200"
									color="brand.500"
									size="xl"
								/>
								<Text textAlign={'center'}>Loading...</Text>
							</Box>
						</Center>
					</Container>
				</Box>
			)}
		</>
	)
}

export default BusinessDetails
